/*
Documentation

*** make sure to declare all action types in actions.js one folder level back

*/

import * as actionTypes from '../../actions';

const initialState = {
    signing_templates: [
       { _id: 123, name: 'signing test 1' },
       { _id: 456, name: 'signing test 2' },
    ],
}

const reducer = (state = initialState, action) => {

    switch (action.type) {

        case actionTypes.SET_SIGNING_TEMPLATES:

            return {
                ...state,
                signing_templates: action.payload,
            }

        default: return state;

    }

}

export default reducer;
